import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ViewRoleProvider } from "./context/ViewRoleContext";
import Login from "./components/auth/Login";
import AppLayout from "./components/layout/AppLayout";
import DashboardOverview from "./components/dashboard/DashboardOverview";
import TodayCockpit from "./components/dashboard/TodayCockpit";
import ChantiersView from "./components/chantiers/ChantiersView";
import PipelineKanban from "./components/pipeline/PipelineKanban";
import DevisView from "./components/devis/DevisView";
import CatalogueView from "./components/catalogue/CatalogueView";
import ClientsView from "./components/clients/ClientsView";
import AnalyticsModule from "./components/analytics/AnalyticsModule";
import AdminView from "./components/admin/AdminView";
import ImportView from "./components/import/ImportView";
import ActionsView from "./components/actions/ActionsView";
import StatsAvancees from "./components/analytics/StatsAvancees";
import AssistantView from "./components/assistant/AssistantView";
import BusinessHunter from "./components/hunter/BusinessHunter";
import ArchivesView from "./components/archives/ArchivesView";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-slate-400">
        Chargement…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <ViewRoleProvider>{children}</ViewRoleProvider>;
}

function Shell() {
  return (
    <Protected>
      <AppLayout />
    </Protected>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell />}>
              <Route index element={<DashboardOverview />} />
              <Route path="ma-journee" element={<TodayCockpit />} />
              <Route path="chantiers" element={<ChantiersView />} />
              <Route path="pipeline" element={<PipelineKanban />} />
              <Route path="actions" element={<ActionsView />} />
              <Route path="devis" element={<DevisView />} />
              <Route path="catalogue" element={<CatalogueView />} />
              <Route path="clients" element={<ClientsView />} />
              <Route path="analytics" element={<AnalyticsModule />} />
              <Route path="statistiques" element={<StatsAvancees />} />
              <Route path="assistant" element={<AssistantView />} />
              <Route path="business-hunter" element={<BusinessHunter />} />
              <Route path="archives" element={<ArchivesView />} />
              <Route path="admin" element={<AdminView />} />
              <Route path="import" element={<ImportView />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{ style: { background: "#FFFFFF", border: "1px solid #E3EBF5", color: "#102A4C" } }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
